import prospectPicto from '../pictos/researcher.png'
import emailPicto from '../pictos/email.png'
import formPicto from '../pictos/form.png'
import phonePicto from '../pictos/smartphone.png'
import visitPicto from '../pictos/building.png'
import meetingPicto from '../pictos/meeting.png'
import notePicto from '../pictos/note.png'

export const noteTypes = {
    "Email": {"picto": emailPicto},
    "Phone call": {"picto": phonePicto},
    "Prospection": {"picto": prospectPicto},
    "Form data": {"picto": formPicto},
    "Visit": {"picto": visitPicto},
    "Meeting": {"picto": meetingPicto},
    "Note": {"picto": notePicto},
}

export const purchaseOrderStatusOptions = ["draft", "for signature", "signed", "rejected", "invoiced", "cancelled"]

export const purchaseOrderStatusLabelColors = {
    draft: 'gray',
    'for signature': 'blue',
    signed: 'green',
    rejected: 'red',
    invoiced: 'purple',
    cancelled: 'orange',
    sent: 'blue',
    accepted: 'green',
}

export const unitStatusOptions = ["available", "sold", "rented", "inactive", "demolished"]

export const unitStatusLabelColors = {
    available: "gray",
    sold: "green", 
    rented: "blue",
    inactive: "lightgray",
    demolished: "lightgray"
}

export const unitTypes = ["Apartment", "House", "Parking", "Office", "Commercial", "Warehouse", "Storage", "Student Room", "Room", "Land", "Industrial Building", "Other"]

export const epcLabelOptions = ["A+", "A", "B", "C", "D", "E", "F", "G", "onbepaald"]

// Rental contract types and label colors
export const rentalContractTypes = ["woninghuur", "studentenhuur", "gemene huur", "handelshuur", "bezetting", "pacht"]

export const rentalContractTypeLabelColors = {
  woninghuur: 'blue',
  studentenhuur: 'orange',
  'gemene huur': 'purple',
  handelshuur: 'gray',
  bezetting: 'red',
  pacht: 'green',
  woning: 'blue',
  student: 'orange',
  handel: 'gray',
}
